import { VisualIdentity } from '@interface/visual-identity';
import * as dayjs from 'dayjs';

const OMNI_VISUAL_IDENTITY = 'omni-visual-identity';

export default class Utils {
  static removeAccents(newStringComAcento): string {

    if (!newStringComAcento) {
      return '';
    } else if (newStringComAcento === null) {
      console.log('Campo nulo');
    }

    let str = newStringComAcento;

    const mapaAcentosHex = {
      a: /[\xE0-\xE6]/g,
      A: /[\xC0-\xC6]/g,
      e: /[\xE8-\xEB]/g,
      E: /[\xC8-\xCB]/g,
      i: /[\xEC-\xEF]/g,
      I: /[\xCC-\xCF]/g,
      o: /[\xF2-\xF6]/g,
      O: /[\xD2-\xD6]/g,
      u: /[\xF9-\xFC]/g,
      U: /[\xD9-\xDC]/g,
      c: /\xE7/g,
      C: /\xC7/g,
      n: /\xF1/g,
      N: /\xD1/g,
    };

    for (const letra in mapaAcentosHex) {
      if (mapaAcentosHex[letra]) {
        const expressaoRegular = mapaAcentosHex[letra];
        str = str.replace(expressaoRegular, letra);
      }
    }

    return str;
  }

  static filterString(filterField: string, filterSearch: string): boolean {
    filterField = this.removeAccents(filterField);
    filterSearch = this.removeAccents(filterSearch);
    return !filterSearch || filterSearch === '' || filterField.toLowerCase().includes(filterSearch.toLowerCase());
  }

  static alterVisualIdentity() {
    const vi = JSON.parse(localStorage.getItem(OMNI_VISUAL_IDENTITY)) as VisualIdentity;

    if (vi) {
      document.documentElement.style.setProperty('--primary-color', vi.themeColor);
      document.documentElement.style.setProperty('--button-font-color', vi.buttonColorFont);
      document.documentElement.style.setProperty('--navbar-color', vi.navbarColor);
      document.documentElement.style.setProperty('--content-navbar-color', vi.contentNavbarColor);
    } else {
      this.defaultVisualIdentity();
    }
  }

  static defaultVisualIdentity() {
    document.documentElement.style.setProperty('--primary-color', '#716ae4');
    document.documentElement.style.setProperty('--button-font-color', '#fff');
    document.documentElement.style.setProperty('--navbar-color', '#fff');
    document.documentElement.style.setProperty('--content-navbar-color', '#262631');
  }

  static getLogo() {
    return (JSON.parse(localStorage.getItem(OMNI_VISUAL_IDENTITY)) as VisualIdentity).photo;
  }

  /**
   * Format date time filter. Returns formatted start time and formatted end time
   *
   * @param startDate - Start date.. if unknown consider today
   * @param endDate - End date.. if unknown consider today or start date
   * @param time - Time.. if unknown consider 00:00 to 23:59
   */
  static formatDateTime(startDate?: string, endDate?: string, time?: string): any {
    let formattedStartDate: string = startDate ? startDate : dayjs().format('YYYY-MM-DD');
    let formattedEndDate: string = endDate ? endDate : formattedStartDate;

    const formattedStartTime = time ? `${time}:00.000`: `00:00:00.000`;
    const formattedEndTime = time ? `${time}:00.000`: `23:59:00.000`;

    return {
      startDate: `${formattedStartDate}T${formattedStartTime}Z`,
      endDate: `${formattedEndDate}T${formattedEndTime}Z`
    };
  }

  /**
   * Format TZ Date
   *
   * @param dateTime - DateToFormat
   */
  static formatTZDateTime(dateTime?: string): string {
    if (dateTime) {
      const year = dateTime.substring(0, 4);
      const month = dateTime.substring(5, 7);
      const day = dateTime.substring(8, 10);
      const hour = dateTime.substring(11, 13);
      const min = dateTime.substring(14, 16);
      const sec = dateTime.substring(17, 19);

      return `${day}/${month}/${year} ${hour}:${min}:${sec}`;
    } else {
      return null;
    }
  }

  /**
   * Generate dynamic link for download CSV
   *
   * @param event - JSON data
   * @param reportName - CSV report name for generate
   */
  static generateCSV(event: any, reportName: string) {
    let arrData = typeof event != 'object' ? JSON.parse(event) : event;
    let CSV = 'sep=,' + '\r\n\n';
    let row = '';

    for (let index in arrData[0]) {
      row += index + ',';
    }

    row = row.slice(0, -1);

    CSV += row + '\r\n';

    for (let i = 0; i < arrData.length; i++) {
      row = '';

      for (let index in arrData[i]) {
        row += '"' + arrData[i][index] + '",';
      }

      row.slice(0, row.length - 1);

      CSV += row + '\r\n';
    }

    let fileName = `sendfy_${reportName}`;

    var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

    let link = document.createElement("a") as any;
    link.href = uri;

    link.style = "visibility:hidden";
    link.download = fileName + ".csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  static getMonthRange(month: number, year: number): any {
    return {
      startDate: dayjs(`${year}-${month}-1`).startOf('month').format('YYYYMMDD'),
      endDate: dayjs(`${year}-${month}-1`).endOf('month').format('YYYYMMDD')
    };
  }

  static getDaysOfMoth(month: number, year: number): string[] {
    let days = [];
    let startDate = dayjs(`${year}-${month}-1`).startOf('month');
    const endDate = dayjs(`${year}-${month}-1`).endOf('month');
    days.push(startDate.format('YYYY-MM-DD'));
    while (startDate.format('YYYY-MM-DD') !== endDate.format('YYYY-MM-DD')) {
      startDate = startDate.add(1, 'day');
      days.push(startDate.format('YYYY-MM-DD'));
    }
    return days;
  }

  static genPassword(): string {
    let chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let passwordLength = 12;
    let password = "";

    for (let i = 0; i <= passwordLength; i++) {
      let randomNumber = Math.floor(Math.random() * chars.length);
      password += chars.substring(randomNumber, randomNumber +1);
    }
    return password;
  }

  static isNumeric(val) {
    return /^-?\d+$/.test(val);
  }

  static csvJSON(csv) {
    let lines=csv.split("\n");
    let result = [];
    let headers=lines[0].split(";");

    for(let i=1;i<lines.length;i++){
      let obj = {};
      let currentline=lines[i].split(";");

      for(let j=0;j<headers.length;j++){
        obj[headers[j].trim()] = currentline[j]?.trim();
      }

      result.push(obj);
    }

    return result;
  }
}
